import React from "react";
import { useCookies } from "react-cookie";
import ReactGA from "react-ga";
import { Route, Switch, Redirect } from "react-router-dom";
import NotFound from "../components/404";
import { settingLastPath } from "../components/common/DeepLink";
import DoctorDashboardLayout from "../components/common/LayoutDoctor/index";
import DoctorOnboarding from "../components/DoctorOnboarding/DoctorOnboarding";
import { default as DoctorProfileLegacy } from "../components/DoctorProfile";
import DoctorProfile from "../components/DoctorProfile/DoctorProfile";
import DoctorVideo from "../components/DoctorVideo";
import DoctorVideoStatics from "../components/InstantConsultation/Common/DoctorVideoStatics";
import DoctorInstantConsult from "../components/InstantConsultation/DoctorInstantConsult";
import SignInContainer from "../components/SignInContainer";
import DoctorLogin from "../components/DoctorLogin";
import DoctorLoginImage from "../assets/doctorLoginAssets/doctor_login_image.png";
import DoctorLoginMobileImage from "../assets/doctorLoginAssets/doctor_login_mobile_image.png";
import DoctorVideoComponent from "../components/DoctorVideoComponent";

const DoctorRoutesNew = () => {
  ReactGA.pageview(window.location.pathname);

  const [cookies, setCookie, removeCookie] = useCookies(["cookie-name"]);

  settingLastPath("doctor", setCookie, removeCookie);
  return (
    <Switch>
      {/* path using left menu */}
      <Route
        path="/doctor/account"
        render={(props) => <DoctorDashboardLayout {...props} />}
      />
      <Route path="/doctor/onboarding" exact component={NotFound} />
      <Route path="/doctor/login">
        <SignInContainer
          renderComp={<DoctorLogin />}
          loginImage={DoctorLoginImage}
          loginMobileImage={DoctorLoginMobileImage}
        />
      </Route>
      {/* <Route path="/doctor/video" exact component={DoctorVideo} /> */}
      <Route path="/doctor/video" exact component={DoctorVideoComponent} />
      <Route path="/doctor/video/:id" exact component={DoctorVideoStatics} />
      <Route
        path="/doctor/instant_consultation"
        exact
        component={DoctorInstantConsult}
      />
      <Route
        path="/doctor/onboarding/:slug"
        exact
        component={DoctorOnboarding}
      />
      <Route path="/doctor/:slug" component={DoctorProfile} />
      <Route
        path="/doctor/legacy/:slug"
        exact
        component={DoctorProfileLegacy}
      />
      <Route render={() => <Redirect to={"/"} />} />
    </Switch>
  );
};

export default DoctorRoutesNew;
